<!-- 
<div style="font-family: Poppins;">

    <div class="d-flex justify-content-between align-items-center" style="background-color: #4561c0;">
        <div class="p-2">
            <span class="dialog-header">
                {{ data.title }}
            </span>
        </div>

        <div class="p-2" style="margin: 0 0 -5px 0px !important;">
            <mat-icon mat-dialog-close class="close-icon" style="color: rgba(138, 152, 171, 1);">
                close
            </mat-icon>
        </div>
    </div>

    <div class="my-2 p-3" style="font-weight:500;font-size:13px;overflow-y:auto;flex:1;max-height:400px;">

        <div *ngFor="let key of data.content | keyvalue" class="mb-2">

            <b>{{ key.key }}:</b>

            <ng-container *ngIf="isLink(key?.value); else normalText">

                <span style="margin-left:5px;">Business Rules</span>

                <img src="../../../assets/svgIcons/attachment_blue.svg"
                    style="height:18px;width:18px;cursor:pointer;margin-left:6px;" title="Open attachment"
                    (click)="openFile(key)" />

            </ng-container>

            <ng-template #normalText>
                <span style="margin-left:5px;">
                    {{ key.value }}
                </span>
            </ng-template>

        </div>

    </div>

    <div class="d-flex justify-content-end align-items-center">
        <div style="margin: 7px 10px;">
            <button type="button" class="btn btn-outline-primary cancel-button" mat-dialog-close>
                Cancel
            </button>
        </div>
    </div>
</div> -->



<div class="dialog-wrapper">

    <!-- Header -->
    <div class="dialog-header">
        <div>
            <h3>{{ data.title }}</h3>
        </div>

        <div class="header-right">
            <span class="close" (click)="onCancel()">✕</span>
        </div>
    </div>

    <div class="dialog-body">

        <!-- Overview -->
        <div class="card" *ngIf="!isAttachmentOpen && !data.isAttachmentOpen">
            <h4>Overview</h4>

            <div class="two-col">
                <ng-container *ngFor="let item of data.content | keyvalue">

                    <!-- Show only NON links -->
                    <ng-container *ngIf="!isLink(item.value)">
                        <div>
                            <label>{{ item.key }}</label>
                            <p>{{ item.value ? item.value : 'null'}}</p>
                        </div>
                    </ng-container>

                </ng-container>
            </div>
        </div>

        <!-- Attachments -->
        <div class="card card-attachments" *ngIf="!isAttachmentOpen && data.isAttachmentexists">
            <h4>Attachments</h4>

            <ng-container *ngFor="let item of data.content | keyvalue">

                <!-- Show only LINKS -->
                <ng-container *ngIf="isLink(item.value)">
                    <div class="attachment-item">

                        <div class="file-info">
                            <img src="../../../assets/svgIcons/attachment_blue.svg"
                                style="height:18px;width:18px;cursor:pointer;margin-left:6px;" title="Open attachment"
                                (click)="openFile(item.value)" />
                            <span>{{ item.key }}</span>
                        </div>

                    </div>
                </ng-container>

            </ng-container>

            <!-- Empty state -->
            <div *ngIf="!hasAttachments()" class="no-file">
                No attachments available
            </div>
            
        </div>

         <div class="card" *ngIf="isAttachmentOpen || data.isAttachmentOpen">
            <h4>Preview</h4>

            <div class="two-col">
                <ng-container *ngFor="let item of data.content | keyvalue">

                    <!-- Show only NON links -->
                    <ng-container *ngIf="isLink(item.value)">
                        <div>
                            <label>{{ 'Business Rule' }}</label>
                            <p>{{ item.value }}</p>
                        </div>
                    </ng-container>

                </ng-container>
            </div>
        </div>

    </div>

</div>

